<template>
  <transition name="product">
    <div class="ClueEntry1">
      <van-nav-bar
        fixed
        v-if="!iscomponent"
        title="线索录入"
        left-arrow
        @click-left="() => $router.go(-1)"
      />
      <b-row>
        <b-col md="12 mb-30" :class="{ 'mt-5': !iscomponent }">
          <b-card>
            <div class="card-form-title">
              <img src="@/assets/imgs/企业资料.png" alt />
              <span class="h5 card-title">企业资料</span>
            </div>
            <b-button
              @click="addCompany"
              class="paramary_color"
              variant="primary"
              >{{ addCompanyBtnText }}</b-button
            >
            <div style="margin-top: 10px">
              <el-tabs v-model="activeName" closable @tab-remove="removeTab">
                <el-tab-pane
                  v-for="(item, index) in allCompany"
                  :key="item.tabIndex"
                  :label="item.companyName"
                  :name="item.tabIndex"
                ></el-tab-pane>
              </el-tabs>
            </div>
            <b-form @submit.prevent="formSubmit">
              <b-row>
                <b-form-group2
                  class="col-md-6 mb-3"
                  label="企业名称"
                  label-for="input-1"
                >
                  <b-row>
                    <b-col cols="8">
                      <!-- <b-form-input
                        type="text"
                        v-model.trim="form.companyName"
                        required
                        placeholder="请输入企业全称"
                      ></b-form-input>-->

                      <el-autocomplete
                        style="width: 100%"
                        class="inline-input search-input"
                        v-model="activeCompanyInfo.companyName"
                        :fetch-suggestions="fuzzySearch"
                        :trigger-on-focus="false"
                        placeholder="请输入企业全称"
                        @select="handleSelect"
                      ></el-autocomplete>
                    </b-col>
                    <b-col cols="4">
                      <b-button
                        class="paramary_color"
                        @click="sevacom()"
                        variant="primary ripple "
                        >直接保存</b-button
                      >
                    </b-col>
                  </b-row>
                </b-form-group2>
                <b-form-group2
                  class="col-md-6 mb-3"
                  label="统一社会信用代码"
                  label-for="input-1"
                >
                  <b-row>
                    <b-col cols="8">
                      <b-form-input
                        type="text"
                        v-model.trim="activeCompanyInfo.creditCode"
                        placeholder="请输入完整的企业信用代码"
                      ></b-form-input>
                    </b-col>
                  </b-row>
                </b-form-group2>
                <b-form-group
                  class="col-md-6 mb-3"
                  label="法人身份证号"
                  label-for="input-1"
                >
                  <b-form-input
                    v-model="activeCompanyInfo.corporateIDCard"
                    type="text"
                    placeholder
                  ></b-form-input>
                </b-form-group>
                <b-form-group
                  class="col-md-6 mb-3"
                  label="企业法人"
                  label-for="input-1"
                >
                  <b-form-input
                    disabled
                    v-model="activeCompanyInfo.corporate"
                    type="text"
                    placeholder
                  ></b-form-input>
                </b-form-group>
                <b-form-group
                  class="col-md-6 mb-3"
                  label="注册资金"
                  label-for="input-1"
                >
                  <b-form-input
                    disabled
                    v-model="activeCompanyInfo.registeredCapital"
                    type="text"
                    placeholder
                  ></b-form-input>
                </b-form-group>
                <b-form-group
                  disabled
                  class="col-md-6 mb-3"
                  label="注册地址"
                  label-for="input-1"
                >
                  <b-form-input
                    disabled
                    v-model="activeCompanyInfo.companyLocation"
                    type="text"
                    placeholder
                  ></b-form-input>
                </b-form-group>
                <b-form-group
                  class="col-md-6 mb-3"
                  label="办公地址"
                  label-for="input-1"
                >
                  <b-form-input
                    disabled
                    v-model="activeCompanyInfo.officeAddress"
                    type="text"
                    placeholder
                  ></b-form-input>
                </b-form-group>
                <b-form-group label="成立时间" class="col-md-6 mb-3">
                  <b-form-input
                    disabled
                    v-model="activeCompanyInfo.established"
                    class="input"
                    type="text"
                  ></b-form-input>
                </b-form-group>
                <b-form-group
                  v-if="false"
                  class="col-md-6 mb-3"
                  label="所属行业"
                  label-for="input-1"
                >
                  <b-form-input
                    disabled
                    v-model="activeCompanyInfo.canye"
                    type="text"
                    placeholder
                  ></b-form-input>
                </b-form-group>
                <b-form-group
                  class="col-md-6 mb-3"
                  label="企业状态"
                  label-for="input-1"
                >
                  <b-form-input
                    disabled
                    v-model="activeCompanyInfo.enterpriseState"
                    type="text"
                    placeholder
                  ></b-form-input>
                </b-form-group>
                <b-form-group
                  class="col-md-6 mb-3"
                  label="所属行业"
                  label-for="input-1"
                >
                  <b-form-input
                    disabled
                    v-model="activeCompanyInfo.industry"
                    type="text"
                    placeholder
                  ></b-form-input>
                </b-form-group>
                <b-form-group
                  class="col-md-12 mb-3"
                  label="经营范围"
                  label-for="input-1"
                >
                  <b-form-textarea
                    disabled
                    rows="4"
                    v-model="activeCompanyInfo.businessScope"
                    type="text"
                    no-resize
                    placeholder
                  ></b-form-textarea>
                </b-form-group>
                <b-form-group
                  label="信用评级"
                  label-for="input-1"
                  class="col-md-12"
                >
                  <b-form-input
                    disabled
                    v-model="activeCompanyInfo.creditRating"
                    type="text"
                    placeholder
                  ></b-form-input>
                </b-form-group>
              </b-row>
              <div class="card-form-title">
                <img src="@/assets/imgs/项目概述.png" alt />
                <span class="h5 card-title">项目资料</span>
              </div>

              <b-row>
                <div class="form-group col-md-4 mb-3">
                  <b class="ColorRed">*</b>
                  <label for="input-1">项目名称</label>
                  <b-form-input
                    v-model="form.projectName"
                    type="text"
                    required
                    placeholder="请输入项目名称"
                  ></b-form-input>
                </div>
                <div class="form-group col-md-4 mb-3">
                  <b class="ColorRed">*</b>
                  <label for="input-1">投资主体</label>
                  <b-form-input
                    type="text"
                    v-model="tzzt"
                    readonly
                    required
                    placeholder="未选择合作企业"
                  >
                  </b-form-input>
                </div>

                <div class="form-group col-md-4 mb-3">
                  <b class="ColorRed">*</b>
                  <label for="input-1">企业类型</label>
                  <el-select
                    v-model="form.qylx"
                    multiple
                    placeholder="请选择"
                    collapse-tags
                    collapse-tags-tooltip
                    :max-collapse-tags="3"
                    style="width: 100%; display: block"
                  >
                    <el-option
                      v-for="item in options_qylx"
                      :key="item.value"
                      :label="item.text"
                      :value="item.text"
                    ></el-option>
                  </el-select>
                </div>
                <div class="form-group col-md-4 mb-3">
                  <b class="ColorRed">*</b>
                  <label for="input-1">产业类别</label>
                  <b-form-select
                    v-model="form.projectType"
                    :options="options_cylb"
                    required
                    id="inline-form-custom-select-pref1"
                  ></b-form-select>
                </div>
                <b-form-group2
                  label="产业方向"
                  label-for="input-1"
                  class="col-md-4 mb-3"
                >
                  <b-form-select
                    v-model="form.canye"
                    required
                    :options="options3"
                  ></b-form-select>
                </b-form-group2>

                <div class="form-group col-md-4 mb-3">
                  <b class="ColorRed">*</b>
                  <label for="input-1">项目类别(状态)</label>
                  <b-form-select
                    v-model="form.state"
                    :options="options_state"
                    required
                    id="inline-form-custom-select-pref1"
                  ></b-form-select>
                </div>

                <div class="form-group col-md-4 mb-3" >
                  <label for="input-1">合同投资额(亿元)</label>
                  <b-form-input type="text" v-model="form.httz"></b-form-input>
                </div>

                <div class="form-group col-md-4 mb-3">
                  <label for="input-1">(拟)转办单位 </label>
                  <b-form-select
                    v-model="form.lzbdw"
                    :options="options_orgs"
                    id="inline-form-custom-select-pref1"
                  ></b-form-select>
                </div>

                <div class="form-group col-md-4 mb-3" >
                  <label for="input-1">项目选址区域</label>
                  <b-form-select
                    v-model="form.luoHuDiZhi"
                    :options="planaddress"
                    id="inline-form-custom-select-pref1"
                  ></b-form-select>
                </div>

                <div
                  class="form-group col-md-1 mb-2"
                  label="企业联系人"
                  
                >
                  <label for="input-1">企业联系人</label>
                  <b-form-input
                    v-model="form.contactPerson"
                    type="text"
                    placeholder="请输入联系人姓名"
                  ></b-form-input>
                </div>
                <div class="form-group col-md-3 mb-3" >
                  <label for="input-1">企业联系电话</label>
                  <b-form-input
                    v-model="form.contactNumber"
                    type="text"
                    placeholder="请输入联系电话"
                  ></b-form-input>
                </div>

                <b-form-group2
                  class="col-md-12 mb-3"
                  label="项目建设内容"
                  label-for="input-1"
                >
                  <b-form-textarea
                    v-model="form.projectDescription"
                    no-resize
                    size="2000"
                    rows="3"
                    required
                    type="text"
                  ></b-form-textarea>
                </b-form-group2>

                <b-form-group2
                  class="col-md-12 mb-3"
                  label="项目推进情况"
                  label-for="input-1"
                >
                  <b-form-textarea
                    no-resize
                    v-model="form.xmtj"
                    size="2000"
                    rows="3"
                    required
                    type="text"
                  ></b-form-textarea>
                </b-form-group2>

                <div class="form-group col-md-6 mb-3" v-if="iszz">
                  <b class="ColorRed">*</b>
                  <label for="input-1">项目参与</label>
                  <b-form-select
                    v-model="form.JoinProject"
                    :options="participatelist"
                    required
                    id="inline-form-custom-select-pref1"
                  ></b-form-select>
                </div>

                <b-form-group
                  label="备注"
                  label-for="input-1"
                  class="col-md-12"
                >
                  <b-form-textarea
                    v-model="form.description"
                    type="text"
                    rows="3"
                    placeholder
                  ></b-form-textarea>
                </b-form-group>
                <b-col md="12 text-center">
                  <b-button
                    class="mt-3"
                    :disabled="false"
                    type="submit"
                    variant="primary"
                    >创建</b-button
                  >
                  <div v-once class="typo__p" v-if="loading">
                    <div class="spinner sm spinner-primary mt-3"></div>
                  </div>
                </b-col>
              </b-row>
            </b-form>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </transition>
</template>
<script>
import { Notify } from "vant";
import { getAllSassOrg } from "@/apis/company";
import {
  constants_options_cyfx,
  constants_options_cylb,
  constants_options_project_state,
  constants_options_qylx,
  constants_optisons_jhld,
  constants_options_xmcy,
} from "@/constants";
const form = {
  id: 0,
  buildType: "",
  projectName: "",
  projectNature: 0,
  projectDescription: "",
  contactPerson: "",
  projectType: 0,
  contactNumber: "",
  projectSource: 0,
  JoinProject: "",
  projectSourceDesc: "",
  projectLocation: "",
  investmentFunds: 0,
  projectBackground: "",
  projectDetails: "",
  companyName: "",
  creditCode: "",
  canye: "",

  description: "",
  corporateID: "",
  userId: 0,
  createUserId: 0,
  client: "",
  companyId: 0,
  companys: "",
  fcMoney: 0,

  //落户地址
  luoHuDiZhi: "",
  canye: "",
  xmtj: "", //项目推进情况
  lzbdw: "", //(拟)转办单位
  qylx: [], //企业类型
  state: "招商线索", //项目类别
  httz: null, //合同投资额(亿元)
};
export default {
  name: "InvestMent",
  props: {
    iscomponent: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading:false,
      planaddress: [
        {
          value: "",
          text: "请选择",
        },
        ...constants_optisons_jhld,
      ],
      iszz: false,
      participatelist: [
        { value: "", text: "请选择" },
        { text: "精准提供信息", value: "精准提供信息" },
        { text: "参与推动跟踪", value: "参与推动跟踪" },
        { text: "全程落地跟踪", value: "全程落地跟踪" },
      ],
      options_qylx: [...constants_options_qylx],
      options_state: [
        { value: "", text: "请选择" },
        ...constants_options_project_state,
      ],
      options_cylb: [{ value: "", text: "请选择" }, ...constants_options_cylb],
      options_orgs: [],
      participatelist: [
        { value: "", text: "请选择" },
        ...constants_options_xmcy,
      ],
      buildtype: [
        {
          value: "",
          text: "请选择",
        },
        { value: "新建", text: "新建" },
        { value: "扩建", text: "扩建" },
        { value: "改建和技术改造", text: "改建和技术改造" },
        { value: "单纯建造生活设施", text: "单纯建造生活设施" },
        { value: "迁建", text: "迁建" },
        { value: "恢复", text: "恢复" },
        { value: "单纯购置", text: "单纯购置" },
      ],
      tabIndex: 1,
      addCompanyBtn: "添加企业",
      allCompany: [
        {
          companyName: "企业信息",
          corporate: "",
          creditCode: "",
          corporateIDCard: "",
          registeredCapital: "",
          companyLocation: "",
          officeAddress: "",
          established: "",
          industry: "",
          enterpriseState: "",
          businessScope: "",
          creditRating: "",
          tabIndex: "1",
          companyId: "0",
        },
      ],
      projecttype: [
        {
          value: "",
          text: "请选择",
        },
        ...constants_options_cylb,
      ],
      options3: [{ value: "", text: "请选择" }, ...constants_options_cyfx],
      options5: [{ text: "请选择", value: "" }, ...constants_options_cyfx],
      activeName: "1",
      activeCompanyInfo: {
        companyName: "",
        corporate: "",
        creditCode: "",
        corporateIDCard: "",
        registeredCapital: "",
        companyLocation: "",
        officeAddress: "",
        established: "",
        industry: "",
        enterpriseState: "",
        businessScope: "",
        creditRating: "",
        companyId: "0",
        canye: "",
        luoHuDiZhi: "",
      },
      options1: [{ value: "", text: "请选择" }],
      options2: [{ value: "", text: "请选择" }],
      form: {
        Canye: "",
        luoHuDiZhi: "",
      },
    };
  },
  methods: {
    addCompany() {
      let newTabName = ++this.tabIndex + "";
      newTabName = "添加企业信息" + this.tabIndex;
      this.allCompany.push({
        companyName: newTabName,
        tabIndex: this.tabIndex + "",
      });
      this.activeName = this.tabIndex + "";
    },
    removeTab(targetName) {
      if (targetName == "1") {
        Notify({ type: "warning", message: "主体企业不可删除" });
      } else {
        let tabs = this.allCompany;
        let activeName = this.activeName;
        if (activeName === targetName) {
          tabs.forEach((tab, index) => {
            if (tab.tabIndex === targetName) {
              let nextTab = tabs[index + 1] || tabs[index - 1];
              if (nextTab) {
                activeName = nextTab.tabIndex;
              }
            }
          });
        }

        this.activeName = activeName;
        this.allCompany = tabs.filter((tab) => tab.tabIndex !== targetName);
      }
    },
    handleSelect() {
      this.getFormData(1);
    },
    querySearch(queryString, cb) {
      var restaurants = this.companyList;
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        );
      };
    },
    fuzzySearch(queryString, cb) {
      if (this.queryString != "") {
        this.request({
          url: "/v1.0/company/companyFuzzySearch",
          method: "GET",
          params: { searchkey: this.activeCompanyInfo.companyName },
        }).then((res) => {
          if (res.status == 200) {
            if (res.data) {
              cb(
                res.data.map((item) => {
                  return { value: item.name };
                })
              );
            } else {
              cb([]);
            }
          }
        });
      } else {
        cb([]);
      }
    },
    formSubmit(evt) {
      evt.preventDefault();
      this.form.client = "weixin";
      let urlType = this.iscomponent ? "Zijian" : "ThePublic";
      let {
        companyName,
        corporate,
        creditCode,
        corporateIDCard,
        registeredCapital,
        companyLocation,
        officeAddress,
        established,
        industry,
        enterpriseState,
        businessScope,
        creditRating,
        companyId,
      } = this.allCompany[0];
      this.form.companyName = companyName;
      this.form.corporate = corporate;
      this.form.creditCode = creditCode;
      this.form.corporateIDCard = corporateIDCard;
      this.form.registeredCapital = registeredCapital;
      this.form.companyLocation = companyLocation;
      this.form.officeAddress = officeAddress;
      this.form.established = established;
      this.form.industry = industry;
      this.form.enterpriseState = enterpriseState;
      this.form.businessScope = businessScope;
      this.form.creditRating = creditRating;
      this.form.companyId = companyId;
     
      
      let otherCompany = [];
      for (let i = 1; i < this.allCompany.length; i++) {
        if (this.allCompany[i].companyId) {
          otherCompany.push(this.allCompany[i].companyId);
        }
      }
      const companys = otherCompany.join(",");
      this.form.companys = companys;
      console.log(this.form);
      console.log(this.iszz, "wdnmd");
      if (this.iszz) {
        this.form.projectSource = "6";
      }
      let data={...this.form}
      data.qylx = JSON.stringify(this.form.qylx); 
      this.request({
        url: `/v1.0/Clues/cluesInput`,
        method: "POST",
        data: data,
      }).then((res) => {
        if (res.success) {
          this.$toast.success("创建成功");
          this.form = Object.assign({}, form);
          if (this.iscomponent) {
            location.reload();
          } else {
            this.$router.go(-1);
          }
        }
      });
    },

    sevacom() {
      var comdata = {
        freezingUserId: 0,
        freezingUser: {
          username: "未知",
          idCard: "未知",
          orgId: 0,
          orgName: "未知",
          position: "未知",
          partId: "未知",
          partDescription: "未知",
          jobNumber: "未知",
          policeOrgId: "未知",
          policeOrgCount: 0,
          rank: 0,
          description: "未知",
          lastLoginTime: "2021-11-09T11:56:58.839Z",
          companyName: "未知",
          creditCode: "未知",
          contactName: "未知",
          contactTel: "未知",
          openId: "未知",
          fullName: "未知",
          password: "未知",
          tel: "未知",
          headImage: "未知",
          email: "未知",
          employer: "未知",
          isQuanJu: true,
          userType: 0,
          scopes: "未知",
          introduction: "未知",
          isActive: true,
          creationTime: "2021-11-09T11:56:58.839Z",
          id: 0,
        },
        freezingTime: "2021-11-09T11:56:58.839Z",
        freezingType: 0,
        thawTime: "2021-11-09T11:56:58.839Z",
        creationTime: "2021-11-09T11:56:58.839Z",
        creditCode: "未知",
        ratingDescription: "未知",
        ratingSocre: "未知",
        corporate: "未知",
        corporateID: "未知",
        enterpriseState: "未知",
        established: "2021-11-09T11:56:58.839Z",
        registeredAmount: 0,
        registeredCapital: "未知",
        companyLocation: "未知",
        officeAddress: "未知",
        status: 0,
        employeesJson: "未知",
        isLeaveArea: true,
        leaveAreaDate: "2021-11-09T11:56:58.839Z",
        leaveAreaOrigin: 100,
        leaveAreaDesc: "未知",
        companyName: this.activeCompanyInfo.companyName,
        industry: "未知",
        subIndustry: "未知",
        businessScope: "未知",
        creditRating: "未知",
        ratingLevel: "未知",
        id: 0,
      };
      console.log(JSON.stringify(comdata), 4123);
      this.request({
        url: `/v1.0/Company/InsertCompany`,
        method: "POST",
        data: comdata,
      }).then((res) => {
        console.log("XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX", res);
        this.getFormData(1);
      });
    },

    getFormData(tab) {
      var Searchkey = "";
      let _cmp = this.allCompany[0];
      if (tab == 1) {
        if (this.activeCompanyInfo.companyName.length < 1) {
          this.$toast("请输入企业名称");
          return false;
        }
        Searchkey = this.activeCompanyInfo.companyName;
      } else {
        Searchkey = this.activeCompanyInfo.creditCode;
      }
      this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      // let urlType = this.iscomponent ? "Zijian" : "Company";
      this.request({
        url: `/v1.0/Company/getCompanyInformation`,
        method: "GET",
        params: {
          Searchkey,
        },
      }).then((res) => {
        console.log(res, 88888);
        this.$toast.clear();
        const {
          businessScope,
          companyLocation,
          companyName,
          corporate,
          creditCode,
          creditRating,
          enterpriseState,
          established,
          industry,
          officeAddress,
          ratingDescription,
          registeredCapital,
          companyId,
          canye,
          luoHuDiZhi,
        } = res.data;
        this.activeCompanyInfo = {
          businessScope,
          companyLocation,
          companyName,
          corporate,
          creditCode,
          creditRating,
          enterpriseState,
          established,
          industry,
          officeAddress,
          ratingDescription,
          registeredCapital,
          companyId,
          canye,
          luoHuDiZhi,
        };
        this.allCompany.some((item) => {
          if (item.tabIndex == this.activeName) {
            for (let key in this.activeCompanyInfo) {
              item[key] = this.activeCompanyInfo[key];
            }
          }
        });

        // this.form = {
        //   businessScope,
        //   companyLocation,
        //   companyName,
        //   corporate,
        //   creditCode,
        //   creditRating,
        //   enterpriseState,
        //   established,
        //   industry,
        //   officeAddress,
        //   ratingDescription,
        //   registeredCapital,
        // };
        if (this.iscomponent) {
          this.form.projectSource = "1";
        }
      });
    },
    onClickLeft() {
      this.$router.go(-1);
    },
  },
  created() {
    this.iszz =
      JSON.parse(window.localStorage.getItem("userInfo")).currentUser
        .userType == 400;
    this.form = Object.assign({}, form);
    if (this.iscomponent) {
      this.form.projectSource = "1";
    }
    let urlType = this.iscomponent ? "Zijian" : "Clues";
    this.request({
      url: `/v1.0/${urlType}/getProjectSourceList`,
      method: "GET",
      params: {},
    }).then((res) => {
      res.data.forEach((element) => {
        this.options2.push({ value: element.id, text: element.name });
      });
    });
    this.request({
      url: `/v1.0/${urlType}/getProjectNatureList`,
      method: "GET",
      params: {},
    }).then((res) => {
      res.data.forEach((element) => {
        this.options1.push({ value: element.id, text: element.name });
      });
    });

    getAllSassOrg().then((rest) => {
      let { orgList, orgId } = rest.data;
      this.options_orgs = [
        { text: "请选择", value: 0, sort: 999 },
        ...orgList.map((item) => ({
          text: item.orgName,
          value: item.id,
          sort: item.sort,
        })),
      ];
      let arr = [];
      this.options_orgs.map((item) => {
        if (item.sort != 0) {
          arr.push(item);
        } else {
        }
      });
      this.options_orgs = arr;
    });
    
  },
  computed: {
    tzzt() {
      return this.allCompany.map((x) => x.companyName).join("，");
    },
    addCompanyBtnText() {
      return this.allCompany.length == 0 ? "添加企业" : "添加合作企业";
    },
  },
  watch: {
    activeName(newValue) {
      const idx = this.allCompany.findIndex(
        (item) => item.tabIndex == newValue
      );
      if (idx != -1) {
        this.activeCompanyInfo = this.allCompany[idx];
      }
    },
  },
};
</script>

<style lang="scss" >
@import "@/assets/scss/mixin.scss";
.ClueEntry1 {
  //   width: 100%;
  background-color: rgb(247, 248, 250);
}
.card-form-title {
  img {
    width: 30px;
    vertical-align: bottom;
  }
  color: $button-color;
}
</style>